import { GasStationCreateRequest } from "@1games-ru/region-shared/dist/backend/requests/gas-station";
import { useCallback } from "react";
import CreateEntityMpProvider from "@/core/data-provider/data-mp/create-entity/create-entity-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";

export default function useCreateGasStation() {
  const createGasStation = useCallback(async (data: GasStationCreateRequest) => {
    try {
      const response = await CreateEntityMpProvider.createGasStation(data);
      console.log({
        response,
      });
      if (response instanceof RpcMpProviderSuccessResponse) {
        toast.success("Заправка создана");
        return response.data;
      }
      toast.error("Ошибка создания заправки");
      return false;
    } catch (e) {
      console.log(e);
      toast.error("Ошибка создания заправки");
      return false;
    }
  }, []);

  return {
    createGasStation,
  };
}
